import React from 'react';
import { ArrowsLeftRight } from '@phosphor-icons/react';

const SHORT = { 'Regional Sales Manager': 'RSM', 'National Sales Manager': 'NSM', 'Vice President': 'VP' };
const short = (label) => label.replace(/Regional Sales Manager|National Sales Manager|Vice President/g, (m) => SHORT[m]);

// Live "what would change" summary for proposed discount limits.
export const LimitChangePreview = ({ preview, loading }) => {
  if (loading && !preview) return <div className="text-xs text-[#6D8E87]" data-testid="limit-preview-loading">Checking recent quotes…</div>;
  if (!preview) return null;
  const none = preview.changed === 0;
  return (
    <div className={`rounded-xl border p-4 transition-opacity ${loading ? 'opacity-60' : ''} ${none ? 'border-[#D5E8E4] bg-[#F4F9F7]' : 'border-amber-200 bg-amber-50/70'}`} data-testid="limit-preview">
      <div className="flex items-center gap-2 text-sm font-semibold text-[#052A23]">
        <ArrowsLeftRight size={16} className={none ? 'text-[#00a69c]' : 'text-amber-600'} />
        <span data-testid="limit-preview-summary">
          {none
            ? `No change in routing for the ${preview.quotes_checked} quotes from the last ${preview.window_days} days.`
            : `${preview.changed} of ${preview.quotes_checked} quotes from the last ${preview.window_days} days would route differently`}
        </span>
      </div>
      {!none && (
        <>
          <div className="flex flex-wrap gap-2 mt-3">
            {preview.transitions.map((t) => (
              <span key={t.label} className="text-xs font-semibold px-2.5 py-1 rounded-full bg-white border border-amber-200 text-amber-900" data-testid="limit-preview-transition">
                {t.count} · {short(t.label)}
              </span>
            ))}
          </div>
          <div className="mt-3 max-h-48 overflow-y-auto rounded-lg border border-amber-100 bg-white divide-y divide-amber-50">
            {preview.samples.map((q) => (
              <div key={q.id} className="flex items-center justify-between gap-3 px-3 py-1.5 text-xs" data-testid="limit-preview-row">
                <span className="truncate text-[#052A23]">
                  <b className="font-mono">{q.quotation_number}</b> · {q.customer_name || '—'} · {q.created_by_name}
                </span>
                <span className="shrink-0 text-[#6D8E87]">{q.max_discount_pct}% · {short(q.from)} → <b className="text-amber-800">{short(q.to)}</b></span>
              </div>
            ))}
          </div>
          <p className="text-[11px] text-[#6D8E87] mt-2">Quotes already pending keep their current approver; this shows how similar quotes will route from now on.</p>
        </>
      )}
    </div>
  );
};
